import PropTypes from "prop-types";
import React from "react";

/**
 * SimpleSvg render an SVG element with given path definition.
 */
export const SimpleSvg = (props) => {
  const {
    className,
    fill,
    height = 32,
    paths,
    role,
    stroke = "primary-300",
    strokeWidth = 1,
    style,
    viewBox,
    width = 32,
  } = props;

  return paths?.length ? (
    <svg {...getProps()}>
      {paths.map((path, index) => (
        <path d={path} key={index} />
      ))}
    </svg>
  ) : null;

  function getProps() {
    return {
      "aria-label": props["aria-label"],
      className,
      fill: `var(--${fill})`,
      height,
      role,
      stroke: `var(--${stroke})`,
      strokeWidth,
      style,
      viewBox,
      width,
    };
  }
};

SimpleSvg.displayName = "SimpleSvg";

SimpleSvg.propTypes = {
  /** aria-label text to provide additional accessibility description for the button element. */
  "aria-label": PropTypes.string,

  /** Additional classes for positioning the component. */
  className: PropTypes.string,

  /** Semantic color value such as "danger-500". */
  fill: PropTypes.string,

  /* Height in pixels. */
  height: PropTypes.number,

  /** Content that will be rendered. */
  paths: PropTypes.arrayOf(PropTypes.string),

  /** Optional role property for accessibility. */
  role: PropTypes.string,

  /** Semantic color value such as "danger-500". */
  stroke: PropTypes.string,

  /** Width of stroke as a string, such as 3. */
  strokeWidth: PropTypes.number,

  /** CSS object to applied to SVG element. */
  style: PropTypes.object,

  /** ViewBox string using a format like: "0 0 32 32". */
  viewBox: PropTypes.string,

  /* Width in pixels. */
  width: PropTypes.number,
};
